var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-justify"},[_c('div',{staticClass:"content-wrapper"},[(_vm.preloader)?_c('app-overlay-loader'):_vm._e(),_vm._v(" "),_c('parent-interview-tab-booking-table',{attrs:{"value":this.value}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }